var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getLocalCount > 0)?_c('span',{staticClass:"z-messages-num__txt"},[_vm._v(_vm._s(_vm.getLocalCount))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }